import React from "react";
import { useMediaQuery } from "react-responsive";
import Skeleton from "@mui/material/Skeleton";
import MDBox from "components/MDBox";

export default function ProfileLoader() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  return (
    <MDBox
      sx={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: isDesktopOrLaptop ? "10px" : "1%",
        rowGap: "10px",
        //   marginRight: isTabletOrMobile ? null : "10rem",
        //   marginLeft: isTabletOrMobile ? null : "10rem",
      }}
    >
      <Skeleton
        sx={{
          bgcolor: "grey.900",
          width: { xs: 110, sm: 110, md: 300 },
          height: { xs: 110, sm: 110, md: 300 },
        }}
        variant="rectangular"
      />
      <Skeleton
        sx={{
          bgcolor: "grey.900",
          width: { xs: 110, sm: 110, md: 300 },
          height: { xs: 110, sm: 110, md: 300 },
        }}
        variant="rectangular"
      />
      <Skeleton
        sx={{
          bgcolor: "grey.900",
          width: { xs: 110, sm: 110, md: 300 },
          height: { xs: 110, sm: 110, md: 300 },
        }}
        variant="rectangular"
      />
    </MDBox>
  );
}
